import React from "react";
import ReactApexChart from "react-apexcharts";
 
export default function PieChart({ labels, data, colors, isPercentage }) {
  const options = {
    chart: {
      type: "pie",
    },
    series: data || [],
    labels: labels || [],
    colors: colors || ["#008FFB", "#00E396", "#FEB019", "#FF4560", "#775DD0"],
    legend: {
      show: true,
      position: "bottom",
      horizontalAlign: "center",
      fontSize: "6px",
    },
    tooltip: {
      y: {
        formatter: function(value) {
          return isPercentage ? value + "%" : value;
        }
      }
    },
    dataLabels: {
      formatter: function(val, opts) {
        return isPercentage ? opts.w.config.series[opts.seriesIndex] + "%" : opts.w.config.series[opts.seriesIndex];
      }
    },
    responsive: [
      {
        breakpoint: 600,
        options: {
          legend: {
            show: true,
          },
        },
      },
    ],
  };
 
  return (
    <div style={{ width: "100%", height: 350, display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ width: "100%", height: "100%" }}>
            <ReactApexChart options={options} series={options.series} type="pie" height={"100%"} />
        </div>
    </div>
  );
}